const template = document.querySelector('[data-template="page.trustedby"]');
const sourceBlock = template?.querySelector('.text-block--text_VGWjr4');
const sourceContent = sourceBlock?.firstElementChild;

if (sourceBlock && sourceContent) {
  const protectedNames = new Map([['DEEN - BURBIGO', 'DEEN BURBIGO']]);

  const cleanName = (name) =>
    name
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .replace(/\s+-\s*$/g, '')
      .trim();

  const splitNames = (text) => {
    let cleanText = cleanName(text);
    protectedNames.forEach((replacement, original) => {
      cleanText = cleanText.replaceAll(original, replacement);
    });

    return cleanText
      .split(/\s+-\s+|\n+/)
      .map(cleanName)
      .filter(Boolean);
  };

  const collectEntries = (node, link = '') => {
    if (node.nodeType === Node.TEXT_NODE) {
      return splitNames(node.textContent).map((name) => ({ name, link }));
    }

    if (node.nodeName === 'BR') {
      return [];
    }

    if (!(node instanceof HTMLElement)) {
      return [];
    }

    const currentLink = node.matches('a') ? node.getAttribute('href') || '' : link;

    return Array.from(node.childNodes).flatMap((child) => collectEntries(child, currentLink));
  };

  const uniqueEntries = Array.from(
    new Map(collectEntries(sourceContent).map((entry) => [entry.name.toLowerCase(), entry])).values()
  ).sort((a, b) => a.name.localeCompare(b.name));

  const initials = Array.from(new Set(uniqueEntries.map((entry) => entry.name.charAt(0).toUpperCase()))).filter((letter) =>
    /^[A-Z]$/.test(letter)
  );

  const getRange = (name) => {
    const initial = name.charAt(0).toUpperCase();

    if (initial >= 'A' && initial <= 'F') return 'af';
    if (initial >= 'G' && initial <= 'M') return 'gm';
    if (initial >= 'N' && initial <= 'S') return 'ns';
    if (initial >= 'T' && initial <= 'Z') return 'tz';

    return 'all';
  };

  sourceBlock.innerHTML = `
    <div class="trusted-by-directory" data-trusted-by-directory>
      <div class="trusted-by-directory__controls">
        <div class="trusted-by-directory__search">
          <input type="search" placeholder="Search artists" aria-label="Search artists" data-artist-search>
        </div>
        <div class="trusted-by-directory__filters" aria-label="Artist filters">
          <button type="button" class="is-active" data-artist-filter="all">All</button>
          <button type="button" data-artist-filter="linked">Linked</button>
          <button type="button" data-artist-filter="af">A-F</button>
          <button type="button" data-artist-filter="gm">G-M</button>
          <button type="button" data-artist-filter="ns">N-S</button>
          <button type="button" data-artist-filter="tz">T-Z</button>
        </div>
      </div>
      <div class="trusted-by-directory__letters" aria-label="Artist initials">
        <button type="button" class="is-active" data-artist-letter="all">All</button>
        ${initials.map((letter) => `<button type="button" data-artist-letter="${letter}">${letter}</button>`).join('')}
      </div>
      <div class="trusted-by-directory__grid" role="list" data-artist-grid></div>
      <p class="trusted-by-directory__empty" hidden data-artist-empty>No artists found.</p>
    </div>
  `;

  const directory = sourceBlock.querySelector('[data-trusted-by-directory]');
  const search = directory.querySelector('[data-artist-search]');
  const filterButtons = Array.from(directory.querySelectorAll('[data-artist-filter]'));
  const letterButtons = Array.from(directory.querySelectorAll('[data-artist-letter]'));
  const grid = directory.querySelector('[data-artist-grid]');
  const empty = directory.querySelector('[data-artist-empty]');
  let activeFilter = 'all';
  let activeLetter = 'all';

  uniqueEntries.forEach((entry) => {
    const tagName = entry.link ? 'a' : 'span';
    const item = document.createElement(tagName);

    item.className = 'trusted-by-directory__artist';
    item.dataset.name = entry.name.toLowerCase();
    item.dataset.initial = entry.name.charAt(0).toUpperCase();
    item.dataset.range = getRange(entry.name);
    item.dataset.linked = String(Boolean(entry.link));
    item.role = 'listitem';
    item.textContent = entry.name;

    if (entry.link) {
      item.href = entry.link;
      item.target = '_blank';
      item.rel = 'noopener noreferrer';
    }

    grid.append(item);
  });

  const updateButtons = (buttons, activeValue, attribute) => {
    buttons.forEach((button) => {
      button.classList.toggle('is-active', button.dataset[attribute] === activeValue);
    });
  };

  const filterArtists = () => {
    const query = search.value.trim().toLowerCase();
    let visibleCount = 0;

    Array.from(grid.children).forEach((item) => {
      const matchesSearch = item.dataset.name.includes(query);
      const matchesFilter =
        activeFilter === 'all' ||
        (activeFilter === 'linked' && item.dataset.linked === 'true') ||
        item.dataset.range === activeFilter;
      const matchesLetter = activeLetter === 'all' || item.dataset.initial === activeLetter;
      const isVisible = matchesSearch && matchesFilter && matchesLetter;

      item.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    empty.hidden = visibleCount > 0;
  };

  filterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      activeFilter = button.dataset.artistFilter;
      updateButtons(filterButtons, activeFilter, 'artistFilter');
      filterArtists();
    });
  });

  letterButtons.forEach((button) => {
    button.addEventListener('click', () => {
      activeLetter = button.dataset.artistLetter;
      updateButtons(letterButtons, activeLetter, 'artistLetter');
      filterArtists();
    });
  });

  search.addEventListener('input', filterArtists);
  filterArtists();
}
